module.exports = __webpack_public_path__ + "img/00038.54d7987e.webp";